import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {addMessageBoxInfo} from '../../common/messageBox/actions/actions';
import {getUrlParameters} from '../../common/util/urlParameters';

export const getProviderSuggestedOrders = (provider, partType) => apiActionCreator({
  'endpoint': `/orders/providers${getUrlParameters({provider, partType})}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PROVIDER_SUGGESTED_ORDER_REQUEST,
    [
      ActionTypes.GET_PROVIDER_SUGGESTED_ORDER_SUCCESS,
    ],
    [
      ActionTypes.GET_PROVIDER_SUGGESTED_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const processProviderStockOrder = (data, partialSave = false) => apiActionCreator({
  'endpoint': '/orders/providers',
  'authenticated': true,
  'types': [
    ActionTypes.PROCESS_PROVIDER_STOCK_ORDER_REQUEST,
    [
      {
        'type': ActionTypes.PROCESS_PROVIDER_STOCK_ORDER_SUCCESS,
        'payload': partialSave,
      },
      (response) => {
        if (partialSave) {
          return addMessageBoxInfo(`El progreso del pedido ${data.orderCode} se guardó satisfactoriamente`);
        }

        return addMessageBoxInfo(`Pedido de stock generado satisfactoriamente ${response.data}`);
      },
    ],
    [
      ActionTypes.PROCESS_PROVIDER_STOCK_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': {...data, partialSave},
});

export const cancelProviderStockOrder = (orderCode) => apiActionCreator({
  'endpoint': '/orders/providers',
  'authenticated': true,
  'types': [
    ActionTypes.CANCEL_PROVIDER_STOCK_ORDER_REQUEST,
    [
      ActionTypes.CANCEL_PROVIDER_STOCK_ORDER_SUCCESS,
      (response) => addMessageBoxInfo(`El pedido sugerido ${orderCode} fue cancelado.`),
    ],
    [
      ActionTypes.CANCEL_PROVIDER_STOCK_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': {orderCode},
});

export const deleteProviderStockOrderPart = (orderInfo, ordersToDelete, partialSave = false) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/orders/providers',
      'authenticated': true,
      'types': [
        ActionTypes.DELETE_PROVIDER_ORDER_PART_REQUEST,
        [
          () => {
            dispatch(processProviderStockOrder(orderInfo, partialSave));
            return {'type': ActionTypes.DELETE_PROVIDER_ORDER_PART_SUCCESS};
          },
        ],
        [
          ActionTypes.DELETE_PROVIDER_ORDER_PART_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'DELETE',
      'contentType': 'application/json',
      'data': {ordersToDelete, 'orderCode': orderInfo.orderCode},
    }));
};

export const getPartSOQResume = (partCode) => apiActionCreator({
  'endpoint': `/parts/${partCode}/soq-resume`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PART_SOQ_RESUME_REQUEST,
    [
      ActionTypes.GET_PART_SOQ_RESUME_SUCCESS,
    ],
    [
      ActionTypes.GET_PART_SOQ_RESUME_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const checkProviderStockOrderCode = (order, values = {}, parameters = {}) => {
  const urlParameters = getUrlParameters({'provider': values.provider, ...parameters});

  return apiActionCreator({
    'endpoint': `/orders/providers/${order.partCode}${urlParameters}`,
    'authenticated': true,
    'types': [
      ActionTypes.CHECK_PROVIDER_STOCK_ORDER_CODE_REQUEST,
      [
        {
          'type': ActionTypes.CHECK_PROVIDER_STOCK_ORDER_CODE_SUCCESS,
          'payload': {...values, order},
        },
      ],
      [
        {
          'type': ActionTypes.CHECK_PROVIDER_STOCK_ORDER_CODE_FAILED,
          'payload': {values, order},
        },
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const checkMadStatus = () => {
  return apiActionCreator({
    'endpoint': '/orders/providers/mad-status',
    'authenticated': true,
    'types': [
      ActionTypes.CHECK_MAD_STATUS_REQUEST,
      [
        {
          'type': ActionTypes.CHECK_MAD_STATUS_SUCCESS,
        },
      ],
      [
        {
          'type': ActionTypes.CHECK_MAD_STATUS_FAILED,
        },
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const generateProviderStockOrder = (provider, itemType) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/orders/providers/generator',
    'authenticated': true,
    'types': [
      ActionTypes.GENERATE_PROVIDER_STOCK_ORDER_REQUEST,
      [
        () => {
          dispatch(getProviderSuggestedOrders(provider, itemType));

          return {'type': ActionTypes.GENERATE_PROVIDER_STOCK_ORDER_SUCCESS};
        },
      ],
      [
        ActionTypes.GENERATE_PROVIDER_STOCK_ORDER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': {provider, 'inenStatus': itemType},
  }));
};

export const restoreProviderSuggestedOrders = () => ({
  'type': ActionTypes.RESTORE_PROVIDER_SUGGESTED_ORDERS,
});

export const changeSuggestedOrderParameter = (name, value) => ({
  'type': ActionTypes.CHANGE_SUGGESTED_ORDER_PARAMETER,
  'payload': {name, value},
});

export const changeSuggestedOrderFilter = (name, value) => ({
  'type': ActionTypes.CHANGE_SUGGESTED_ORDER_FILTER,
  'payload': {name, value},
});

export const editSuggestedOrderPartCode = (value, order) => ({
  'type': ActionTypes.EDIT_SUGGESTED_ORDER_PART_CODE,
  'payload': {order, value},
});

export const editSuggestedOrderPartQuantity = (value, order) => ({
  'type': ActionTypes.EDIT_SUGGESTED_ORDER_PART_QUANTITY,
  'payload': {order, value},
});

export const addSuggestedOrderElement = () => ({
  'type': ActionTypes.ADD_NEW_REGISTER_TO_SUGGESTED_ORDER,
});

export const removeSuggestedOrderElement = (selectedOrder) => ({
  'type': ActionTypes.REMOVE_REGISTER_FROM_SUGGESTED_ORDER,
  'payload': selectedOrder,
});

export const sortSuggestedOrderElements = (key, direction = 'ascending') => ({
  'type': ActionTypes.SORT_SUGGESTED_ORDER_ELEMENTS,
  'payload': {key, direction},
});

export const showOrderPartDetails = (partCode, partName, partIndex = null) => ({
  'type': ActionTypes.SHOW_ORDER_PART_DETAILS,
  'payload': {partCode, partName, partIndex},
});

export const hideOrderPartDetails = () => ({
  'type': ActionTypes.HIDE_ORDER_PART_DETAILS,
});

export const showOrderPartBackOrder = (partCode) => ({
  'type': ActionTypes.SHOW_ORDER_PART_BACK_ORDER,
  'payload': partCode,
});

export const hideOrderPartBackOrder = () => ({
  'type': ActionTypes.HIDE_ORDER_PART_BACK_ORDER,
});

export const showOrderPartOnOrder = (partCode) => ({
  'type': ActionTypes.SHOW_ORDER_PART_ON_ORDER,
  'payload': partCode,
});

export const hideOrderPartOnOrder = () => ({
  'type': ActionTypes.HIDE_ORDER_PART_ON_ORDER,
});

export const showOrderPartSOQResume = (partCode) => ({
  'type': ActionTypes.SHOW_ORDER_PART_SOQ_RESUME,
  'payload': partCode,
});

export const hideOrderPartSOQResume = () => ({
  'type': ActionTypes.HIDE_ORDER_PART_SOQ_RESUME,
});

export const changeSuggestedOrderInvalidCode = (value) => ({
  'type': ActionTypes.CHANGE_SUGGESTED_ORDER_INVALID_CODE,
  'payload': value,
});

export const toggleDeleteMarkInSuggestedOrderElement = (partCode) => ({
  'type': ActionTypes.TOGGLE_DELETE_MARK_OF_SUGGESTED_ORDER_ELEMENT,
  'payload': partCode,
});
